import React from "react";
import { Button, Form, Input, Row, Col, Select, notification } from "antd";
import { api_srv } from "services";
import { useQuery } from "react-query";
import Loader from "../loader";
import { create_client_quotation, list_cover_types } from "services/apiSrv";
import { useMutation } from "react-query";
import { ModalContext } from "context/ModalContext";
import { useContext } from "react";
const { TextArea } = Input;
const { Option } = Select;

function AddClientQuotation({ refetch }) {
  const [form] = Form.useForm();
  const { modalClose } = useContext(ModalContext);

  const fetch_subclass = async () => {
    let resp = await (await api_srv).get_subclass();
    console.log("THE SUBCLASSES", resp.insurance_sub_classes);
    return resp.insurance_sub_classes;
  };

  const { data, isLoading, isSuccess } = useQuery("subclasses", fetch_subclass);
  console.log("SUB CLASSui", data)
  

  // Fetch cover types
  const {
    data: coverTypes,
    isLoading: isCoverTypesLoading,
    isSuccess: isCoverTypesSuccess,
    isError: isCoverTypesError,
  } = useQuery("coverTypes", list_cover_types);

  console.log("Cover types", coverTypes)

  const validateMessages = {
    required: "${label} is required!",
  };

  const mutation = useMutation(create_client_quotation, {
    onSuccess: (data) => {
      notification.success({
        message: "Success",
        description: "Quotation created successfully!",
      });
      modalClose()
      form.resetFields();
      refetch()
    },
    onError: (error) => {
      notification.error({
        message: "Error",
        description: "Failed to create quotation. Please try again.",
      });
    },
  });


  const onFinish = (values) => {
    console.log("Quotation Submitted:", values);
    const quotationData = {
       client_names: values.client_names,
       quotation_remarks: values.quotation_remarks,
       client_email: values.client_email,
       client_contact: values.client_contact,
       guest_client_quotation_ref: values.guest_client_quotation_ref,
       cover_type_code: values.cover_type_code,
       insurance_class: values.insurance_class,
    };

    mutation.mutate(quotationData);
  };

  return (
    <div>
    {isLoading && <Loader />}
    {isSuccess && data && (<Form
    form={form}

      name="clientQuotationForm"
      layout="vertical"
      onValuesChange={(changedValues, allValues) => {
        console.log("Changed Values:", changedValues);
        console.log("All Current Values:", allValues);
      }}
      onFinish={onFinish}
      validateMessages={validateMessages}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Insurance Class"
            name="insurance_class"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select Insurance Class">
            {data && data.map((item, i) => (
              <Option key={i} value={item.ira_code}>{item.name}</Option>
            ))}

            </Select>
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label="Client Name"
            name="client_names"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter client name" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
      <Col span={12}>
          <Form.Item
            label="Client Email"
            name="client_email"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter client email" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Client Contact"
            name="client_contact"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter client contact" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Reference"
            name="guest_client_quotation_ref"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter reference number" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label="Cover Type"
            name="cover_type_code"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select Cover Type">
              {coverTypes?.covertypes && coverTypes?.covertypes.map((item, i) => (
                <Option key={i} value={item.code}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        label="Remarks"
        name="quotation_remarks"
        rules={[{ required: true }]}
      >
        <TextArea rows={4} placeholder="Add remarks or notes..." />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
            Create
        </Button>
      </Form.Item>
    </Form>)
      }
    </div>
  
  );
}

export default AddClientQuotation;
